import { httpGet, httpPost, httpPatchMerge, httpDelete } from './../http'
import type { TEntityId } from '~/types/models'
import type { IContactRole } from '~/types/contact/models'

const apiEntityPath = '/api/suppliercontactroles'

export async function getSupplierContactRoles() {
  const callingMn = getSupplierContactRoles.name
  const apiPath = `${apiEntityPath}`
  return httpGet<IContactRole[]>({ callingMn, apiPath })
}

export async function createSupplierContactRole(entity: IContactRole) {
  const callingMn = createSupplierContactRole.name
  const apiPath = apiEntityPath
  return httpPost<IContactRole>({ callingMn, apiPath, entity })
}

export async function updateSupplierContactRole(
  entityData: Partial<IContactRole>,
  id: TEntityId
) {
  const callingMn = updateSupplierContactRole.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialISupplierContactRole = Partial<IContactRole>
  return httpPatchMerge<TPartialISupplierContactRole>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteSupplierContactRole(entityData: IContactRole) {
  const callingMn = deleteSupplierContactRole.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
